import {BookingHistoryStore} from './boooking/history'
import {BookingPageStore} from './boooking/index'
import {BookingStudioPageStore} from './boooking/studio'
import {FeedbackStore} from './feedback'
import {AuthStore} from "./auth";
import NavigationStore from "./navigation-store";
import routerStore from "./router";
import {CabinetMainPageStore} from "./cabinet";

const prepareStores = (history) => {
    const authStore = new AuthStore(routerStore);
    const navigationStore = new NavigationStore(history);
    const bookingHistoryStore = new BookingHistoryStore(routerStore, authStore);
    const cabinetMainPageStore = new CabinetMainPageStore(routerStore, authStore, bookingHistoryStore);
    const bookingPageStore = new BookingPageStore(routerStore, authStore);
    const bookingStudioPageStore = new BookingStudioPageStore(routerStore, authStore);
    const feedbackStore = new FeedbackStore();
    return {
        routerStore: routerStore,
        bookingHistoryStore: bookingHistoryStore,
        feedbackStore: feedbackStore,
        navigationStore: navigationStore,
        authStore: authStore,
        cabinetMainPageStore: cabinetMainPageStore,
        bookingPageStore: bookingPageStore,
        bookingStudioPageStore: bookingStudioPageStore,
    };
};
export default prepareStores;